import { TransactionStatusDto } from './dtos/transactions'

export const enum TransactionStatus {
  Unknown = 'Unknown',
  Pending = 'Pending',
  Canceled = 'Canceled',
  Processing = 'Processing',
  Completed = 'Completed',
}

export function parseTransactionStatus(
  dto: TransactionStatusDto,
): TransactionStatus {
  switch (dto) {
    case 'PENDING':
      return TransactionStatus.Pending
    case 'CANCELED':
      return TransactionStatus.Canceled
    case 'PROCESSING':
      return TransactionStatus.Processing
    case 'COMPLETED':
      return TransactionStatus.Completed
  }
  console.warn('Unknown transaction status', dto)
  return TransactionStatus.Unknown
}
